export default __webpack_public_path__ + "static/media/tokenomicsimg.b46c6f93.png";